"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = buildDashboardFilterPayload;
var _lodash = require("lodash");
var _flattenServiceTypes = _interopRequireDefault(require("../serviceTypes/flattenServiceTypes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function findServiceType(serviceTypes, id) {
  return (0, _lodash.find)(serviceTypes, {
    id: id
  });
}
function buildServiceTypeNames(serviceTypes, ids) {
  var serviceTypeNames = ids.map(function (id) {
    var serviceType = findServiceType(serviceTypes, id);
    return (0, _lodash.get)(serviceType, 'name');
  });
  return (0, _lodash.compact)(serviceTypeNames);
}
function findCareCoordinator(coordinators, id) {
  return (0, _lodash.find)(coordinators, {
    user: {
      id: id
    }
  });
}
function buildCoordinatorObjects(coordinators, ids) {
  var coordinatorsObjects = ids.map(function (filterId) {
    var coordinator = findCareCoordinator(coordinators, filterId);
    if (coordinator) {
      return {
        id: (0, _lodash.get)(coordinator, 'user.id'),
        full_name: (0, _lodash.get)(coordinator, 'user.full_name')
      };
    }
    return null;
  });
  return (0, _lodash.compact)(coordinatorsObjects);
}
function buildDashboardFilterPayload(state, props) {
  var filters = {};
  (0, _lodash.forIn)((0, _lodash.get)(state, 'filters', []), function (value, key) {
    switch (key) {
      case 'service_types':
        {
          var serviceTypes = (0, _flattenServiceTypes["default"])((0, _lodash.get)(props, 'serviceTypes', []), true);
          filters[key] = buildServiceTypeNames(serviceTypes, value);
          break;
        }
      case 'referral_sender_users':
      case 'care_coordinator_users':
        {
          var coordinators = (0, _lodash.get)(props, 'careCoordinators', []);
          filters[key] = buildCoordinatorObjects(coordinators, value);
          break;
        }
      default:
        filters[key] = value;
    }
  });
  return filters;
}